/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

interface Client {
  id: string;
  name: string;
  selected: boolean;
  inView: boolean;
}

interface AddClientAutocompleteProps {
  options: Client[];
  onClientAdd: (client: Client | null) => void;
  disabled?: boolean;
}

const AddClientAutocomplete = ({
  options,
  onClientAdd,
  disabled = false,
}: AddClientAutocompleteProps) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: Client | null,
  ) => {
    onClientAdd(newValue);
    setInputValue("");
  };

  const handleInputChange = (
    event: React.SyntheticEvent | null,
    newInputValue: string,
  ) => {
    if (event && event.type === "change") {
      setInputValue(newInputValue);
    }
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.name}
      onChange={handleChange}
      value={undefined}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      disableClearable
      size="small"
      disabled={disabled}
      sx={{
        width: 300,
        "& .MuiOutlinedInput-root": {
          paddingRight: "8px",
          "& fieldset": {
            borderColor: "grey.400",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Add Client"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <AddIcon
                fontSize="small"
                sx={{ ml: 1, mr: 0.5, color: "primary.main" }}
              />
            ),
          }}
        />
      )}
    />
  );
};

export default AddClientAutocomplete;
